
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-edit");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/edit/index.js
// module id = 0+Go
// module chunks = 12